import React, { FC } from 'react'
import { Column } from '@components/UI-Components/HierarchyWiseItemsTable/models/column'
import QuantityKPICell from './QunatityKPICell'
import { useTranslation } from 'react-i18next'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import { makeStyles } from '@material-ui/core'
import classNames from 'classnames'
import BookUnbookAllButton from './BookUnbookAllButton'
import find from 'lodash/find'
import { useObserver } from 'mobx-react-lite'
import useOrderContext from '@modules/order/hooks/use-order-context'
import useViewContext from '@modules/order/hooks/use-view-context'
import { EnhancedListDataStore } from '@modules/showroom/EnhancedOrder/stores/EnhancedListView/EnhancedListDataStore'
import { EnhancedListUIStore } from '@modules/showroom/EnhancedOrder/stores/EnhancedListView/EnhancedListUIStore'
import { isRetailClient } from '@utils/get-channel-name'
import { nav } from '@stores'

export interface CellProps {
  column?: Column
  customClass?: any
}
const useStyles = makeStyles(theme => ({
  enhancedCellWrapper: {
    height: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#eeeeee',
    borderBottom: '1px solid #ccc',
    padding: '0px 5px'
  },
  customBorder: {
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      borderRight: '2px #ccc solid',
      right: 0,
      height: '50%',
      marginTop: 'auto',
      marginBottom: 'auto'
    }
  },
  cell: {
    display: '-webkit-box',
    overflow: 'hidden',
    textAlign: 'center',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    width: '100%'
  },
  cellIcon: {
    display: 'flex',
    alignSelf: 'center'
  }
}))
const QuantityHeaderWithKPI: ({ headers, doorOrderId }) => FC<CellProps> =
  ({ headers, doorOrderId }) =>
  ({ column }) =>
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useObserver(function useHook() {
      const {
        uiStore: {
          dataStore: { summary },
          isOrderEditable
        }
      } = useOrderContext()
      const viewContextVal = useViewContext()
      const store = viewContextVal.uiStore as EnhancedListUIStore<EnhancedListDataStore>
      const { label, key, isStickyBorder } = column

      const {
        updateAllProductBookingsForDoor,
        areObjectsDataLoading,
        dataStore: { isProductBookingStatusPending }
      } = store

      const {
        queryParams: { clientType }
      } = nav
      const { t } = useTranslation()
      const classes = useStyles({ isStickyBorder })

      const doorId = column?.field
      const targetDoorOrderId =
        find(summary?.doorOrders, doorOrder => doorOrder?.door?.id === doorId)?.id ||
        summary?.doorOrder?.doorOrderId

      const disableBookUnbookAllButton =
        areObjectsDataLoading || !isOrderEditable || isProductBookingStatusPending
      return headers?.length ? (
        <>
          {headers.map(header => (
            <QuantityKPICell header={header} doorOrderId={doorOrderId} />
          ))}
          <div
            className={classNames(
              classes.enhancedCellWrapper,
              'enhancedCellWrapperOverride',
              {
                [classes.customBorder]: !key,
                customBorderOverride: !key
              }
            )}
          >
            <span className={classes.cell}>
              <Typography variant={'subtitle2DarkGrey'}>
                {key ? t(`order.listview.colHeader.${key}`, label) : label}
              </Typography>
            </span>
            {!key && !column?.initialAllocationField && isRetailClient(clientType) && (
              <div>
                <BookUnbookAllButton
                  disabled={disableBookUnbookAllButton}
                  doorName={key ? t(`order.listview.colHeader.${key}`, label) : label}
                  handleUnBookAll={isUnbookAllOperation => {
                    updateAllProductBookingsForDoor(
                      targetDoorOrderId,
                      isUnbookAllOperation
                    )
                  }}
                />
              </div>
            )}
          </div>
        </>
      ) : (
        <div className={classes.enhancedCellWrapper}>
          <span className={classes.cell}>
            <Typography variant={'subtitle2DarkGrey'}>
              {key ? t(`order.listview.colHeader.${key}`, label) : label}
            </Typography>
          </span>
        </div>
      )
    })

export default QuantityHeaderWithKPI
